import styled, { css } from 'styled-components';
import variables from '@styles/variables';
import { rem } from 'polished';
import Text from '@atoms/Text/Text';

export const StyledProductListItem = styled.div`
  display: flex;
  flex-direction: column;
  min-height: ${rem(88)};
  border-bottom: ${rem(1)} solid ${variables.colors.mediumGray};
  padding: ${rem(20)} ${rem(12)};
`;

export const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const StyledTextWrapper = styled.div<{ $variant?: 'addToList' | 'default' }>`
  display: flex;
  flex-direction: column;
  min-width: ${rem(112)};
  width: ${rem(112)};
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: ${rem(12)};
  margin-left: ${rem(12)};
  flex: 1;

  ${(props) =>
    props.$variant === 'addToList' &&
    css`
      gap: ${rem(4)};
    `}
`;

export const StyledText = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledPromotionText = styled(Text)`
  padding-top: ${rem(6)};
`;

export const StyledAccent = styled.span`
  color: ${variables.colors.primary};
  margin-right: ${rem(5)};
`;

export const StyledSum = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  white-space: nowrap;
  margin-left: ${rem(20)};
`;
